const s = window.$ || window.jQuery;
class i extends HTMLElement {
  constructor() {
    if ((super(), typeof s > 'u')) {
      window.console.error('jQuery is required | product-recommendations.js');
      return;
    }
    this.container = this;
    const t = {rootMargin: '0px 0px 200px 0px'};
    new IntersectionObserver(this.handleIntersection.bind(this), t).observe(this.container);
  }
  handleIntersection(t, o) {
    t[0].isIntersecting &&
      (o.unobserve(this),
      fetch(this.dataset.url)
        .then((e) => {
          if (!e.ok) throw new Error(`Failed to get product recommendations. ${e.status} - ${e.statusText}`);
          return e.text();
        })
        .then((e) => {
          const n = document.createElement('div');
          n.innerHTML = e;
          const r = n.querySelector('product-recommendations');
          r && r.innerHTML.trim().length && (this.innerHTML = r.innerHTML),
            n.querySelector('.cart-upsell__item') && this.classList.add('product-recommendations--loaded'),
            s('.cart-upsell__list').owlCarousel({
              loop: !1,
              margin: 40,
              nav: !1,
              responsive: {0: {items: 2, margin: 10}, 750: {items: 4}},
            });
        })
        .catch((e) => {
          window.console.warn(e);
        }));
  }
}
customElements.get('product-recommendations-cart') || customElements.define('product-recommendations-cart', i);
